// /cosearch/:slug router, uses the existing FeaturePage template with the
// CoSearch catalog and overrides the related-modules link prefix so they
// stay under /cosearch/*.
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import FeaturePage from "@/components/site/FeaturePage";
import { findCoSearchFeature, COSEARCH_FEATURES } from "@/constants/cosearchCatalog";

export default function CoSearchFeatureRouter() {
  const { slug } = useParams();
  const entry = findCoSearchFeature(slug);
  if (!entry) return <Navigate to="/cosearch" replace />;

  // Resolve related slugs against the CoSearch catalog (not the main cosec one)
  const relatedEntries = (entry.related || [])
    .map((s) => findCoSearchFeature(s))
    .filter(Boolean);

  const enriched = {
    ...entry,
    relatedEntries,
    relatedHrefPrefix: "/cosearch",
  };

  return <FeaturePage entry={enriched} />;
}

export { COSEARCH_FEATURES };
